module.exports = __webpack_public_path__ + "img/icon_line.b35be26a.png";